module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container"
  }, [_c('p', {
    staticClass: "line-height-20 margin-t30"
  }, [_vm._v("\n        Escolha um valor de recarga, verifique a taxa de recarga e confirme.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group margin-b0",
    class: {
      'has-error': _vm.errors.has('valueTotal')
    }
  }, [(_vm.unit == -1) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|recargaMinima:' + _vm.minValue),
      expression: "'required|recargaMinima:'+minValue"
    }],
    staticClass: "form-control text-right recharge-input margin-t10",
    attrs: {
      "id": "valueTotal",
      "type": "text",
      "name": "valueTotal",
      "placeholder": "R$ 00,00",
      "spellcheck": "false",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "maxlength": "14"
    },
    domProps: {
      "value": _vm.valueFormatted
    },
    on: {
      "input": function($event) {
        return _vm.setTotal($event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errors.first('valueTotal')) ? _c('div', {
    staticClass: "help-block has-errors"
  }, [_vm._v("\n          " + _vm._s(_vm.errors.first('valueTotal')) + "\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.credit && !_vm.errors.first('valueTotal')) ? _c('div', {
    staticClass: "text-center credit-box"
  }, [_c('p', [_vm._v("Crédito: "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.credit)))]), _vm._v(" | Taxa de Recarga: "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.rate)))])])]) : _vm._e()])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
    staticClass: "alert alert-danger margin-b20"
  }, [_c('p', [_vm._v(_vm._s(_vm.msgError))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-30ab559c!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/recharge/recharge-tax.vue
// module id = 2084
// module chunks = 1